import { Formik } from 'formik'
import React from 'react'
import { useDispatch } from 'react-redux'
import { _, withCapture } from 'utils'
import { MovieType } from 'generated/graphql'
import { showNotification } from '../../notifications'
import { showErrorNotification } from '../../notifications/notificationsSlice'
import { updateMovie } from '../graphql/mutation'
import { FormContent, MovieValidation } from './CreateMovie'
import { getChangedValues } from '../../forms/utils'

interface Props {
    close?: () => void
    callGetMovies?: () => void
    movie?: MovieType
}

const UpdateMovie = ({
    close, callGetMovies, movie,
}: Props) => {
    const dispatch = useDispatch()
    const initialValues = { ...movie, tags: (movie?.tags || []).map((e) => e.id) }

    const onSubmit = withCapture(async (values) => {
        const submitValues = getChangedValues(initialValues, values)
        const response = await updateMovie(movie.id, submitValues)
        if (response.data) {
            dispatch(showNotification({
                type: 'success',
                body: _('form.notification.create_success'),
            }))
            callGetMovies()
            close()
        } else {
            dispatch(showErrorNotification(response.errors))
        }
    })

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={MovieValidation}
            onSubmit={onSubmit}
        >
            <FormContent close={close} />
        </Formik>
    )
}

export default UpdateMovie
